// /home/labdoo/zitech-nexus/frontend/src/pages/ClassMarksDetail.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import './ClassMarksDetail.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Print: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 8H5C3.89543 8 3 8.89543 3 10V16C3 17.1046 3.89543 18 5 18H8M19 8V18H16M19 8H16M16 8V4H8V8M8 18H16M8 18V20C8 21.1046 8.89543 22 10 22H14C15.1046 22 16 21.1046 16 20V18" />
      <circle cx="16" cy="13" r="1" fill="currentColor" />
    </svg>
  ),
  Export: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3V15M12 15L9 12M12 15L15 12" />
      <path d="M4 17V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V17" />
    </svg>
  ),
  Refresh: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  ),
  Close: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Male: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6" />
      <path d="M12 14V22M9 19H15" />
    </svg>
  ),
  Female: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="10" r="6" />
      <path d="M12 16V22M9 19H15" />
    </svg>
  ),
  Pass: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Fail: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Plus: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 5V19M5 12H19" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Delete: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7H20" />
      <path d="M10 11V16" />
      <path d="M14 11V16" />
      <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" />
      <path d="M9 7L10 3H14L15 7" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cmd-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
};

interface StudentMarks {
  id: number;
  serial_number: number;
  candidate_name: string;
  sex: string;
  history_score: number | null;
  geography_score: number | null;
  kiswahili_score: number | null;
  english_score: number | null;
  physics_score: number | null;
  chemistry_score: number | null;
  biology_score: number | null;
  basic_math_score: number | null;
  bookkeeping_score: number | null;
  commerce_score: number | null;
  bible_knowledge_score: number | null;
  civics_score: number | null;
  agriculture_score: number | null;
  arabic_score: number | null;
  sports_score: number | null;
  french_score: number | null;
  total_score: number | null;
  average_score: number | null;
  division: string | null;
  points: number | null;
  position: number | null;
  history_grade: string | null;
  geography_grade: string | null;
  kiswahili_grade: string | null;
  english_grade: string | null;
  physics_grade: string | null;
  chemistry_grade: string | null;
  biology_grade: string | null;
  basic_math_grade: string | null;
  bookkeeping_grade: string | null;
  commerce_grade: string | null;
  bible_knowledge_grade: string | null;
  civics_grade: string | null;
  agriculture_grade: string | null;
  arabic_grade: string | null;
  sports_grade: string | null;
  french_grade: string | null;
}

interface SubjectSummary {
  subject_name: string;
  grade_a_count: number;
  grade_b_count: number;
  grade_c_count: number;
  grade_d_count: number;
  grade_f_count: number;
  total_candidates: number;
  total_passed: number;
  total_failed: number;
  pass_percentage: number;
  average_score: number | null;
}

interface OverallSummary {
  total_students: number;
  total_male: number;
  total_female: number;
  class_average: number | null;
  class_gpa: number | null;
  division_counts: Record<string, number>;
  pass_count: number;
  fail_count: number;
  pass_percentage: number;
  subject_averages: Record<string, number>;
}

interface ClassMarksRecord {
  id: number;
  school_name: string;
  school_registration_number: string;
  class_display: string;
  term_display: string;
  exam_type_display: string;
  exam_year: number;
  exam_month: string;
  center_number: string;
  center_name: string;
  total_students: number;
  status: string;
  status_display: string;
  created_at: string;
  updated_at: string;
  user_name: string;
  user_email: string;
  subjects: string[];
  students: StudentMarks[];
  subject_summaries: SubjectSummary[];
  overall_summary: OverallSummary;
}

interface NewStudentMarks {
  serial_number: number;
  candidate_name: string;
  sex: string;
  history_score: number | null;
  geography_score: number | null;
  kiswahili_score: number | null;
  english_score: number | null;
  physics_score: number | null;
  chemistry_score: number | null;
  biology_score: number | null;
  basic_math_score: number | null;
  bookkeeping_score: number | null;
  commerce_score: number | null;
  bible_knowledge_score: number | null;
  civics_score: number | null;
  agriculture_score: number | null;
  arabic_score: number | null;
  sports_score: number | null;
  french_score: number | null;
}

const defaultSubjects = [
  { key: 'history_score', label: 'History' },
  { key: 'geography_score', label: 'Geography' },
  { key: 'kiswahili_score', label: 'Kiswahili' },
  { key: 'english_score', label: 'English' },
  { key: 'physics_score', label: 'Physics' },
  { key: 'chemistry_score', label: 'Chemistry' },
  { key: 'biology_score', label: 'Biology' },
  { key: 'basic_math_score', label: 'Basic Math' },
];

const availableSubjects = [
  { key: 'bookkeeping_score', label: 'Bookkeeping' },
  { key: 'commerce_score', label: 'Commerce' },
  { key: 'bible_knowledge_score', label: 'Bible Knowledge' },
  { key: 'civics_score', label: 'Civics' },
  { key: 'agriculture_score', label: 'Agriculture' },
  { key: 'arabic_score', label: 'Arabic' },
  { key: 'sports_score', label: 'Sports' },
  { key: 'french_score', label: 'French' },
  { key: 'history_tz_score', label: 'Historia ya Tanzania' },
  { key: 'business_study_score', label: 'Business Study' },
  { key: 'china_score', label: 'Chinese' },
  { key: 'computer_science_score', label: 'Computer Science' },
  { key: 'music_score', label: 'Music' },
  { key: 'fine_arts_score', label: 'Fine Arts' },
];

const ClassMarksDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [record, setRecord] = useState<ClassMarksRecord | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<'students' | 'summary' | 'add'>('students');
  const [editingStudentId, setEditingStudentId] = useState<number | null>(null);
  const [showAddSubject, setShowAddSubject] = useState(false);
  const [sortBy, setSortBy] = useState<'total_score' | 'average_score' | 'points' | 'serial_number'>('total_score');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');
  
  const [newStudent, setNewStudent] = useState<NewStudentMarks>({
    serial_number: 1,
    candidate_name: '',
    sex: 'M',
    history_score: null,
    geography_score: null,
    kiswahili_score: null,
    english_score: null,
    physics_score: null,
    chemistry_score: null,
    biology_score: null,
    basic_math_score: null,
    bookkeeping_score: null,
    commerce_score: null,
    bible_knowledge_score: null,
    civics_score: null,
    agriculture_score: null,
    arabic_score: null,
    sports_score: null,
    french_score: null,
  });

  const [editStudent, setEditStudent] = useState<StudentMarks | null>(null);
  const [subjects, setSubjects] = useState(defaultSubjects);
  const [formValues, setFormValues] = useState<Record<string, string>>({
    candidate_name: '',
    history_score: '',
    geography_score: '',
    kiswahili_score: '',
    english_score: '',
    physics_score: '',
    chemistry_score: '',
    biology_score: '',
    basic_math_score: '',
    bookkeeping_score: '',
    commerce_score: '',
    bible_knowledge_score: '',
    civics_score: '',
    agriculture_score: '',
    arabic_score: '',
    sports_score: '',
    french_score: '',
  });

  useEffect(() => {
    fetchRecord();
  }, [id]);

  useEffect(() => {
    if (record && record.subjects && record.subjects.length > 0) {
      const savedSubjects = record.subjects.map((sub: string) => {
        const found = [...defaultSubjects, ...availableSubjects].find(s => s.key === sub);
        if (found) return found;
        return { key: sub, label: sub.replace('_score', '').replace('_', ' ').toUpperCase() };
      });
      setSubjects(savedSubjects);
    }
  }, [record]);

  useEffect(() => {
    if (record) {
      const maxSerial = record.students?.reduce((max, s) => Math.max(max, s.serial_number), 0) || 0;
      setNewStudent(prev => ({ ...prev, serial_number: maxSerial + 1 }));
    }
  }, [record]);

  const fetchRecord = async () => {
    try {
      const response = await api.get(`/classmarks/records/${id}/`);
      setRecord(response.data);
    } catch (error) {
      console.error('Error fetching record:', error);
      setError('Failed to load marks record');
    } finally {
      setLoading(false);
    }
  };

  const handleNewStudentChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'candidate_name') {
      setNewStudent(prev => ({ ...prev, candidate_name: value }));
    } else if (name === 'sex') {
      setNewStudent(prev => ({ ...prev, sex: value }));
    } else if (name === 'serial_number') {
      setNewStudent(prev => ({ ...prev, serial_number: parseInt(value) || 0 }));
    } else if (name.endsWith('_score')) {
      const numValue = value === '' ? null : Number(value);
      setNewStudent(prev => ({
        ...prev,
        [name]: numValue
      }));
    }
  };

  const handleAddStudent = async () => {
    if (!formValues.candidate_name.trim()) {
      setError('Student name is required');
      return;
    }

    setSaving(true);
    setError(null);

    const studentData: any = {
      serial_number: newStudent.serial_number,
      candidate_name: formValues.candidate_name.trim(),
      sex: newStudent.sex,
    };

    subjects.forEach(subject => {
      const value = formValues[subject.key] || '';
      if (value !== '' && !isNaN(Number(value))) {
        studentData[subject.key] = Number(value);
      } else {
        studentData[subject.key] = null;
      }
    });

    try {
      const response = await api.put(
        `/classmarks/records/${id}/students/${newStudent.serial_number}/`,
        studentData
      );

      if (response.data) {
        await fetchRecord();
        const maxSerial = record?.students?.reduce((max, s) => Math.max(max, s.serial_number), 0) || 0;
        setNewStudent({
          serial_number: maxSerial + 2,
          candidate_name: '',
          sex: 'M',
          history_score: null,
          geography_score: null,
          kiswahili_score: null,
          english_score: null,
          physics_score: null,
          chemistry_score: null,
          biology_score: null,
          basic_math_score: null,
          bookkeeping_score: null,
          commerce_score: null,
          bible_knowledge_score: null,
          civics_score: null,
          agriculture_score: null,
          arabic_score: null,
          sports_score: null,
          french_score: null,
        });
        const resetValues: Record<string, string> = {
          candidate_name: '',
        };
        const allSubjects = [...defaultSubjects, ...availableSubjects];
        allSubjects.forEach(sub => {
          resetValues[sub.key] = '';
        });
        setFormValues(resetValues);
        setActiveTab('students');
        alert('Student added successfully!');
      }
    } catch (err: any) {
      console.error('Error adding student:', err);
      setError(err.response?.data?.error || 'Failed to add student');
    } finally {
      setSaving(false);
    }
  };

  const startEditStudent = (student: StudentMarks) => {
    setEditStudent(student);
    setEditingStudentId(student.id);
    const values: Record<string, string> = {
      candidate_name: student.candidate_name || '',
    };
    const allSubjects = [...defaultSubjects, ...availableSubjects];
    allSubjects.forEach(sub => {
      const score = student[sub.key as keyof StudentMarks] as number | null;
      values[sub.key] = score?.toString() || '';
    });
    setFormValues(values);
    setActiveTab('add');
  };

  const handleEditStudentChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));
    if (editStudent) {
      if (name === 'candidate_name') {
        setEditStudent({ ...editStudent, candidate_name: value });
      } else if (name === 'sex') {
        setEditStudent({ ...editStudent, sex: value });
      } else if (name.endsWith('_score')) {
        const numValue = value === '' ? null : Number(value);
        setEditStudent({
          ...editStudent,
          [name]: numValue
        });
      }
    }
  };

  const handleUpdateStudent = async () => {
    if (!editStudent || !formValues.candidate_name.trim()) {
      setError('Student name is required');
      return;
    }

    setSaving(true);
    setError(null);

    const studentData: any = {
      serial_number: editStudent.serial_number,
      candidate_name: formValues.candidate_name.trim(),
      sex: editStudent.sex,
    };

    subjects.forEach(subject => {
      const value = formValues[subject.key] || '';
      if (value !== '' && !isNaN(Number(value))) {
        studentData[subject.key] = Number(value);
      } else {
        studentData[subject.key] = null;
      }
    });

    try {
      const response = await api.put(
        `/classmarks/records/${id}/students/${editStudent.id}/`,
        studentData
      );

      if (response.data) {
        await fetchRecord();
        setEditingStudentId(null);
        setEditStudent(null);
        const resetValues: Record<string, string> = {
          candidate_name: '',
        };
        const allSubjects = [...defaultSubjects, ...availableSubjects];
        allSubjects.forEach(sub => {
          resetValues[sub.key] = '';
        });
        setFormValues(resetValues);
        setActiveTab('students');
        alert('Student updated successfully!');
      }
    } catch (err: any) {
      console.error('Error updating student:', err);
      setError(err.response?.data?.error || 'Failed to update student');
    } finally {
      setSaving(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingStudentId(null);
    setEditStudent(null);
    const resetValues: Record<string, string> = {
      candidate_name: '',
    };
    const allSubjects = [...defaultSubjects, ...availableSubjects];
    allSubjects.forEach(sub => {
      resetValues[sub.key] = '';
    });
    setFormValues(resetValues);
    setActiveTab('students');
  };

  const handleDeleteStudent = async (studentId: number) => {
    if (!window.confirm('Are you sure you want to delete this student? This action cannot be undone.')) {
      return;
    }

    setSaving(true);
    setError(null);

    try {
      const response = await api.delete(
        `/classmarks/records/${id}/students/${studentId}/`
      );
      
      if (response.data) {
        await fetchRecord();
        alert('Student deleted successfully!');
      }
    } catch (err: any) {
      console.error('Error deleting student:', err);
      setError(err.response?.data?.error || 'Failed to delete student');
    } finally {
      setSaving(false);
    }
  };

  const handleAddSubject = async (subjectKey: string, subjectLabel: string) => {
    if (subjects.some(s => s.key === subjectKey)) {
      setError(`Subject "${subjectLabel}" already exists`);
      return;
    }

    const newSubjects = [...subjects, { key: subjectKey, label: subjectLabel }];
    setSubjects(newSubjects);
    
    setFormValues(prev => ({
      ...prev,
      [subjectKey]: ''
    }));

    setNewStudent(prev => ({
      ...prev,
      [subjectKey]: null
    }));

    try {
      await api.patch(`/classmarks/records/${id}/`, {
        subjects: newSubjects.map(s => s.key)
      });
      await fetchRecord();
    } catch (err) {
      console.error('Error saving subjects:', err);
      setError('Failed to save subjects');
    }

    setShowAddSubject(false);
    setError(null);
  };

  const handleRemoveSubject = async (subjectKey: string) => {
    if (defaultSubjects.some(s => s.key === subjectKey)) {
      setError('Cannot remove default subjects');
      return;
    }

    const newSubjects = subjects.filter(s => s.key !== subjectKey);
    setSubjects(newSubjects);
    
    const newFormValues = { ...formValues };
    delete newFormValues[subjectKey];
    setFormValues(newFormValues);

    try {
      await api.patch(`/classmarks/records/${id}/`, {
        subjects: newSubjects.map(s => s.key)
      });
      await fetchRecord();
    } catch (err) {
      console.error('Error saving subjects:', err);
      setError('Failed to save subjects');
    }

    setError(null);
  };

  const getGradeColor = (grade: string | null): string => {
    if (!grade) return '#6b7280';
    const colors: Record<string, string> = {
      A: '#10b981',
      B: '#0ea5e9',
      C: '#f59e0b',
      D: '#f97316',
      F: '#ef4444',
    };
    return colors[grade] || '#6b7280';
  };

  const getGradeBackground = (grade: string | null): string => {
    if (!grade) return '#f3f4f6';
    const colors: Record<string, string> = {
      A: '#d1fae5',
      B: '#dbeafe',
      C: '#fef3c7',
      D: '#ffedd5',
      F: '#fee2e2',
    };
    return colors[grade] || '#f3f4f6';
  };

  const getStatusColor = (status: string): string => {
    const colors: Record<string, string> = {
      draft: '#6b7280',
      submitted: '#f59e0b',
      processed: '#0ea5e9',
      published: '#10b981',
    };
    return colors[status] || '#6b7280';
  };

  const getStatusBackground = (status: string): string => {
    const colors: Record<string, string> = {
      draft: '#f3f4f6',
      submitted: '#fef3c7',
      processed: '#dbeafe',
      published: '#d1fae5',
    };
    return colors[status] || '#f3f4f6';
  };

  const getScoreDisplay = (score: number | null): string => {
    if (score === null || score === undefined) return '-';
    return score.toString();
  };

  const getSortedStudents = () => {
    if (!record?.students) return [];
    
    const sorted = [...record.students];
    
    sorted.sort((a, b) => {
      let aValue: number = 0;
      let bValue: number = 0;
      
      switch (sortBy) {
        case 'total_score':
          aValue = a.total_score || 0;
          bValue = b.total_score || 0;
          break;
        case 'average_score':
          aValue = a.average_score || 0;
          bValue = b.average_score || 0;
          break;
        case 'points':
          aValue = a.points || 99;
          bValue = b.points || 99;
          return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
        case 'serial_number':
        default:
          aValue = a.serial_number;
          bValue = b.serial_number;
          break;
      }
      
      return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });
    
    return sorted;
  };

  const handleSort = (field: 'total_score' | 'average_score' | 'points' | 'serial_number') => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('desc');
    }
  };

  const getRankDisplay = (index: number): string => {
    const rank = index + 1;
    const suffix = rank === 1 ? 'st' : rank === 2 ? 'nd' : rank === 3 ? 'rd' : 'th';
    return `${rank}${suffix}`;
  };

  const getRankColor = (index: number): string => {
    if (index === 0) return '#f59e0b';
    if (index === 1) return '#9ca3af';
    if (index === 2) return '#cd7f32';
    return '#d1d5db';
  };

  const sortedStudents = getSortedStudents();

  const exportToCSV = () => {
    if (!record || !record.students || record.students.length === 0) {
      alert('No data to export');
      return;
    }

    try {
      const headers = [
        'Serial No',
        'Candidate Name',
        'Sex',
        ...subjects.map(s => `${s.label} Score`),
        ...subjects.map(s => `${s.label} Grade`),
        'Total Score',
        'Average Score',
        'Division',
        'Points'
      ];

      const rows = record.students.map((student) => {
        const row: any[] = [
          student.serial_number,
          student.candidate_name,
          student.sex,
        ];

        subjects.forEach((subject) => {
          const score = student[subject.key as keyof StudentMarks] as number | null;
          const gradeKey = subject.key.replace('_score', '_grade');
          const grade = student[gradeKey as keyof StudentMarks] as string | null;
          row.push(score !== null && score !== undefined ? score : '');
          row.push(grade || '');
        });

        row.push(student.total_score?.toFixed(1) || '');
        row.push(student.average_score?.toFixed(1) || '');
        row.push(student.division || '');
        row.push(student.points || '');

        return row;
      });

      let csvContent = headers.join(',') + '\n';
      
      rows.forEach((row) => {
        const escapedRow = row.map((field) => {
          const str = String(field);
          if (str.includes(',') || str.includes('"') || str.includes('\n')) {
            return `"${str.replace(/"/g, '""')}"`;
          }
          return str;
        });
        csvContent += escapedRow.join(',') + '\n';
      });

      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      const fileName = `Marks_Report_${record.school_name.replace(/\s+/g, '_')}_${record.exam_year}.csv`;
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      alert('CSV file downloaded successfully!');
    } catch (error) {
      console.error('Error exporting CSV:', error);
      alert('Failed to export CSV. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="cmd-loading-container">
        <div className="cmd-spinner">
          <Icons.Spinner />
        </div>
        <p className="cmd-loading-text">Loading marks record...</p>
      </div>
    );
  }

  if (!record) {
    return (
      <div className="cmd-error-container">
        <div className="cmd-error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className="cmd-error-title">Record Not Found</h2>
        <p className="cmd-error-text">The marks record you're looking for doesn't exist or has been removed.</p>
        <button className="cmd-error-btn" onClick={() => navigate('/dashboard/class-marks')}>
          <Icons.Back />
          Back to Records
        </button>
      </div>
    );
  }

  return (
    <div className="cmd-container">
      {/* Header */}
      <div className="cmd-header">
        <div className="cmd-header-left">
          <button className="cmd-back-btn" onClick={() => navigate('/dashboard/class-marks')}>
            <Icons.Back />
            Back
          </button>
          <h1 className="cmd-title">{record.school_name}</h1>
          <div className="cmd-meta">
            <span className="cmd-badge">{record.class_display}</span>
            <span className="cmd-badge">{record.term_display}</span>
            <span className="cmd-badge">{record.exam_type_display} {record.exam_year}</span>
            <span 
              className="cmd-status-badge"
              style={{
                background: getStatusBackground(record.status),
                color: getStatusColor(record.status)
              }}
            >
              <Icons.StatusDot />
              {record.status_display}
            </span>
            <span className="cmd-badge">
              Total: {record.students?.length || 0} Students
            </span>
          </div>
        </div>
        <div className="cmd-header-actions">
          <button 
            className="cmd-btn cmd-btn-print"
            onClick={() => navigate(`/dashboard/class-marks/${id}/print`)}
          >
            <Icons.Print />
            Print Report
          </button>
          <button 
            className="cmd-btn cmd-btn-export"
            onClick={exportToCSV}
          >
            <Icons.Export />
            Export CSV
          </button>
          <button className="cmd-btn cmd-btn-refresh" onClick={fetchRecord}>
            <Icons.Refresh />
            Refresh
          </button>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="cmd-stats-bar">
        <div className="cmd-stat-item">
          <span className="cmd-stat-label">Total Students</span>
          <span className="cmd-stat-value">{record.students?.length || 0}</span>
        </div>
        <div className="cmd-stat-divider"></div>
        <div className="cmd-stat-item">
          <span className="cmd-stat-label">Male</span>
          <span className="cmd-stat-value cmd-stat-male">{record.overall_summary?.total_male || 0}</span>
        </div>
        <div className="cmd-stat-divider"></div>
        <div className="cmd-stat-item">
          <span className="cmd-stat-label">Female</span>
          <span className="cmd-stat-value cmd-stat-female">{record.overall_summary?.total_female || 0}</span>
        </div>
        <div className="cmd-stat-divider"></div>
        <div className="cmd-stat-item">
          <span className="cmd-stat-label">Class Average</span>
          <span className="cmd-stat-value cmd-stat-average">{record.overall_summary?.class_average?.toFixed(1) || '-'}</span>
        </div>
        <div className="cmd-stat-divider"></div>
        <div className="cmd-stat-item">
          <span className="cmd-stat-label">Pass Rate</span>
          <span className="cmd-stat-value cmd-stat-pass">{record.overall_summary?.pass_percentage?.toFixed(1) || 0}%</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="cmd-tabs">
        <button 
          className={`cmd-tab ${activeTab === 'students' ? 'cmd-tab-active' : ''}`}
          onClick={() => setActiveTab('students')}
        >
          Students ({record.students?.length || 0})
        </button>
        <button 
          className={`cmd-tab ${activeTab === 'summary' ? 'cmd-tab-active' : ''}`}
          onClick={() => setActiveTab('summary')}
        >
          Summary
        </button>
        <button 
          className={`cmd-tab ${activeTab === 'add' ? 'cmd-tab-active' : ''}`}
          onClick={() => setActiveTab('add')}
        >
          {editingStudentId ? 'Edit Student' : '+ Add Student'}
        </button>
      </div>

      {/* Content */}
      <div className="cmd-content">
        {error && (
          <div className="cmd-error-alert">
            <span className="cmd-error-alert-icon">⚠️</span>
            <span className="cmd-error-alert-text">{error}</span>
            <button className="cmd-error-alert-close" onClick={() => setError(null)}>
              <Icons.Close />
            </button>
          </div>
        )}

        {/* Students Tab */}
        {activeTab === 'students' && (
          <div className="cmd-table-wrapper">
            <div className="cmd-sort-controls">
              <span className="cmd-sort-label">Sort by:</span>
              <button 
                className={`cmd-sort-btn ${sortBy === 'total_score' ? 'cmd-sort-active' : ''}`}
                onClick={() => handleSort('total_score')}
              >
                Total Score {sortBy === 'total_score' && (sortOrder === 'desc' ? '↓' : '↑')}
              </button>
              <button 
                className={`cmd-sort-btn ${sortBy === 'average_score' ? 'cmd-sort-active' : ''}`}
                onClick={() => handleSort('average_score')}
              >
                Average {sortBy === 'average_score' && (sortOrder === 'desc' ? '↓' : '↑')}
              </button>
              <button 
                className={`cmd-sort-btn ${sortBy === 'points' ? 'cmd-sort-active' : ''}`}
                onClick={() => handleSort('points')}
              >
                Points (Best) {sortBy === 'points' && (sortOrder === 'asc' ? '↓' : '↑')}
              </button>
              <button 
                className={`cmd-sort-btn ${sortBy === 'serial_number' ? 'cmd-sort-active' : ''}`}
                onClick={() => handleSort('serial_number')}
              >
                Serial No. {sortBy === 'serial_number' && (sortOrder === 'asc' ? '↓' : '↑')}
              </button>
            </div>

            <div className="cmd-table-scroll">
              <table className="cmd-table">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>#</th>
                    <th>Name</th>
                    <th>Sex</th>
                    {subjects.map((subject) => (
                      <th key={subject.key}>{subject.label}</th>
                    ))}
                    <th>Total</th>
                    <th>Avg</th>
                    <th>Div</th>
                    <th>Points</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedStudents.map((student, index) => (
                    <tr key={student.id} className={index < 3 ? 'cmd-row-top' : ''}>
                      <td>
                        <span className="cmd-rank-badge" style={{ background: getRankColor(index) }}>
                          {getRankDisplay(index)}
                        </span>
                      </td>
                      <td>{student.serial_number}</td>
                      <td className="cmd-student-name">{student.candidate_name}</td>
                      <td>{student.sex}</td>
                      {subjects.map((subject) => {
                        const score = student[subject.key as keyof StudentMarks] as number | null;
                        const gradeKey = subject.key.replace('_score', '_grade');
                        const grade = student[gradeKey as keyof StudentMarks] as string | null;
                        return (
                          <td key={subject.key}>
                            <div className="cmd-score-grade">
                              <span className="cmd-score-value">{getScoreDisplay(score)}</span>
                              <span 
                                className="cmd-grade-badge" 
                                style={{ 
                                  background: getGradeBackground(grade),
                                  color: getGradeColor(grade)
                                }}
                              >
                                {grade || '-'}
                              </span>
                            </div>
                          </td>
                        );
                      })}
                      <td className="cmd-total-score">{student.total_score?.toFixed(1) || '-'}</td>
                      <td className="cmd-avg-score">{student.average_score?.toFixed(1) || '-'}</td>
                      <td>
                        <span className="cmd-division-badge">{student.division || '-'}</span>
                      </td>
                      <td className="cmd-points">{student.points || '-'}</td>
                      <td>
                        <div className="cmd-actions">
                          <button 
                            className="cmd-action-btn cmd-action-view"
                            onClick={() => startEditStudent(student)}
                            title="View/Edit student"
                          >
                            <Icons.View />
                          </button>
                          <button 
                            className="cmd-action-btn cmd-action-edit"
                            onClick={() => startEditStudent(student)}
                            title="Edit student"
                          >
                            <Icons.Edit />
                          </button>
                          <button 
                            className="cmd-action-btn cmd-action-delete"
                            onClick={() => handleDeleteStudent(student.id)}
                            title="Delete student"
                            disabled={saving}
                          >
                            <Icons.Delete />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {sortedStudents.length === 0 && (
              <div className="cmd-no-students">
                <p>No students added yet. Click the "+ Add Student" tab to add students.</p>
              </div>
            )}
          </div>
        )}

        {/* Summary Tab */}
        {activeTab === 'summary' && record.overall_summary && (
          <div className="cmd-summary">
            <div className="cmd-summary-grid">
              <div className="cmd-summary-card">
                <h4 className="cmd-summary-card-label">Total Students</h4>
                <div className="cmd-summary-card-value">{record.overall_summary.total_students}</div>
                <div className="cmd-summary-card-sub">
                  <Icons.Male /> {record.overall_summary.total_male} | <Icons.Female /> {record.overall_summary.total_female}
                </div>
              </div>
              <div className="cmd-summary-card">
                <h4 className="cmd-summary-card-label">Class Average</h4>
                <div className="cmd-summary-card-value">{record.overall_summary.class_average?.toFixed(1) || '-'}</div>
              </div>
              <div className="cmd-summary-card">
                <h4 className="cmd-summary-card-label">Class GPA</h4>
                <div className="cmd-summary-card-value">{record.overall_summary.class_gpa?.toFixed(2) || '-'}</div>
              </div>
              <div className="cmd-summary-card">
                <h4 className="cmd-summary-card-label">Pass Rate</h4>
                <div className="cmd-summary-card-value">{record.overall_summary.pass_percentage?.toFixed(1) || 0}%</div>
                <div className="cmd-summary-card-sub">
                  <Icons.Pass /> {record.overall_summary.pass_count} | <Icons.Fail /> {record.overall_summary.fail_count}
                </div>
              </div>
            </div>

            <div className="cmd-summary-section">
              <h3 className="cmd-summary-section-title">Division Distribution</h3>
              <div className="cmd-division-chart">
                {Object.entries(record.overall_summary.division_counts || {}).map(([division, count]) => (
                  <div key={division} className="cmd-division-bar">
                    <span className="cmd-division-label">Division {division}</span>
                    <div className="cmd-division-track">
                      <div 
                        className="cmd-division-fill" 
                        style={{ 
                          width: `${(count / record.overall_summary.total_students) * 100}%`,
                          background: division === 'I' ? '#10b981' : 
                                     division === 'II' ? '#0ea5e9' :
                                     division === 'III' ? '#f59e0b' :
                                     division === 'IV' ? '#f97316' : '#ef4444'
                        }}
                      />
                    </div>
                    <span className="cmd-division-count">{count}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="cmd-summary-section">
              <h3 className="cmd-summary-section-title">Subject Performance</h3>
              <div className="cmd-subject-grid">
                {record.subject_summaries?.map((subject) => (
                  <div key={subject.subject_name} className="cmd-subject-card">
                    <h4 className="cmd-subject-card-title">{subject.subject_name}</h4>
                    <div className="cmd-subject-stats">
                      <div className="cmd-subject-stat">
                        <span>Avg</span>
                        <strong>{subject.average_score?.toFixed(1) || '-'}</strong>
                      </div>
                      <div className="cmd-subject-stat">
                        <span>Pass</span>
                        <strong>{subject.pass_percentage?.toFixed(1) || 0}%</strong>
                      </div>
                    </div>
                    <div className="cmd-subject-grades">
                      <span className="cmd-grade-dot cmd-grade-a">A: {subject.grade_a_count}</span>
                      <span className="cmd-grade-dot cmd-grade-b">B: {subject.grade_b_count}</span>
                      <span className="cmd-grade-dot cmd-grade-c">C: {subject.grade_c_count}</span>
                      <span className="cmd-grade-dot cmd-grade-d">D: {subject.grade_d_count}</span>
                      <span className="cmd-grade-dot cmd-grade-f">F: {subject.grade_f_count}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Add Student Tab */}
        {activeTab === 'add' && (
          <div className="cmd-add-student">
            <div className="cmd-add-card">
              <h3 className="cmd-add-card-title">{editingStudentId ? 'Edit Student' : 'Add Student Manually'}</h3>
              <p className="cmd-add-card-subtitle">{editingStudentId ? 'Update student details and subject scores below.' : 'Enter student details and subject scores below.'}</p>

              <div className="cmd-add-subject-section">
                <button
                  type="button"
                  className="cmd-add-subject-btn"
                  onClick={() => setShowAddSubject(!showAddSubject)}
                >
                  <Icons.Plus /> Add Subject
                </button>

                {showAddSubject && (
                  <div className="cmd-add-subject-dropdown">
                    {availableSubjects.map((subject) => {
                      const isAdded = subjects.some(s => s.key === subject.key);
                      return (
                        <button
                          key={subject.key}
                          className={`cmd-add-subject-option ${isAdded ? 'cmd-add-subject-added' : ''}`}
                          onClick={() => !isAdded && handleAddSubject(subject.key, subject.label)}
                          disabled={isAdded}
                        >
                          {subject.label}
                          {isAdded && <Icons.Check />}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="cmd-add-form">
                <div className="cmd-form-row">
                  <div className="cmd-form-group">
                    <label className="cmd-form-label">Serial Number *</label>
                    <input
                      type="number"
                      name="serial_number"
                      className="cmd-form-input"
                      value={editingStudentId ? editStudent?.serial_number || '' : newStudent.serial_number}
                      onChange={editingStudentId ? handleEditStudentChange : handleNewStudentChange}
                      disabled
                    />
                  </div>
                  <div className="cmd-form-group">
                    <label className="cmd-form-label">Student Name *</label>
                    <input
                      type="text"
                      name="candidate_name"
                      className="cmd-form-input"
                      placeholder="Enter student name"
                      value={formValues.candidate_name}
                      onChange={editingStudentId ? handleEditStudentChange : handleNewStudentChange}
                      required
                    />
                  </div>
                  <div className="cmd-form-group">
                    <label className="cmd-form-label">Sex *</label>
                    <select
                      name="sex"
                      className="cmd-form-input"
                      value={editingStudentId ? editStudent?.sex || 'M' : newStudent.sex}
                      onChange={editingStudentId ? handleEditStudentChange : handleNewStudentChange}
                    >
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                </div>

                <div className="cmd-form-row cmd-subjects-row">
                  {subjects.map((subject) => (
                    <div key={subject.key} className="cmd-form-group cmd-subject-input">
                      <label className="cmd-form-label">
                        {subject.label}
                        {!defaultSubjects.some(s => s.key === subject.key) && (
                          <button
                            type="button"
                            className="cmd-remove-subject"
                            onClick={() => handleRemoveSubject(subject.key)}
                            title="Remove subject"
                          >
                            ×
                          </button>
                        )}
                      </label>
                      <input
                        type="number"
                        name={subject.key}
                        className="cmd-form-input"
                        placeholder="Score"
                        min="0"
                        max="100"
                        value={formValues[subject.key] || ''}
                        onChange={editingStudentId ? handleEditStudentChange : handleNewStudentChange}
                      />
                    </div>
                  ))}
                </div>

                <div className="cmd-form-actions">
                  <button
                    type="button"
                    className="cmd-btn-cancel"
                    onClick={editingStudentId ? handleCancelEdit : () => setActiveTab('students')}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="cmd-btn-submit"
                    onClick={editingStudentId ? handleUpdateStudent : handleAddStudent}
                    disabled={saving || !formValues.candidate_name.trim()}
                  >
                    {saving ? 'Saving...' : editingStudentId ? 'Update Student' : 'Add Student'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClassMarksDetail;